// extracted by mini-css-extract-plugin
export default {"container":"GM-z"};